import styled, { css } from "styled-components";
import SnapCarrousel from "../../display/SnapCarrousel/SnapCarrousel";

export const AdsCarouselRoot = styled(SnapCarrousel)(
    () => css`
        padding: 0px 3px 5px 3px;
    `,
);
